import { Injectable } from '@angular/core';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { MetaService } from '../util-meta-service/meta.service';

@Injectable()
export class BrandTitleSuffix extends TitleStrategy {
  public constructor(private readonly meta: MetaService) {
    super();
  }

  public updateTitle(snapshot: RouterStateSnapshot): void {
    const title = this.buildTitle(snapshot);
    if (title) {
      this.meta.updateTitle(title);
    }
  }
}
